'use client';

import { useEffect, useState } from 'react';

/**
 * Returns a boolean stating whether the component is currently mounted.
 */
export function useIsMounted() {
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    return { isMounted };
}
